var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isGrouped)?_c('div',{staticClass:"prime-roster-options-button-container"},[_c('button',{staticClass:"prime-button button-clear",on:{"click":function($event){return _vm.showActions($event)}}},[_c('ion-icon',{attrs:{"name":"md-more"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }